import BaseEntity from './BaseEntity';
import CommitSimple from './CommitSimple';
import File from './File';
import RawReport from './RawReport';
import Report from './Report';
import Tool from './Tool';
export default class CommitDetail extends BaseEntity {
    constructor(data, defects, codeCoverage) {
        super();
        this.fileIds = [];
        this.commit = new CommitSimple(this.parseProperty(data, 'commit'), defects, codeCoverage);
        this.fileIds = this.parseProperty(data, 'fileIds').map(file => new File(file));
        this.newIssuesCount = this.parseProperty(data, 'newIssuesCount');
        this.rawReports = this.parseProperty(data, 'rawReports').map(rawReport => new RawReport(rawReport));
        this.reports = this.parseProperty(data, 'reports').map(report => new Report(report));
        this.tools = this.parseProperty(data, 'tools').map(tool => new Tool(tool));
        this.truncated = this.parseProperty(data, 'truncated');
    }
}
